import React from "react";
import "../../stylesheets2025/Author.css";


export default function ConferenceUI() {
    return (
        <div className="containerAuthor">




            {/* Header */}
            <header className="headerAuthor">
                <h1>Call for Papers</h1>
                <p className="tagline">
                    Energy • Water • Ancient Knowledge Systems
                </p>
            </header>


            <div className="form-container flex flex-col md:flex-row justify-center items-center gap-8 mt-10">
                {/* Author Form */}
                <div className="form text-center">
                    <p>Digest Submissions</p>
                    <a
                        href="https://forms.gle/ArPdVFGjiNu3jCRE8"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Digest Submissions Link
                    </a>
                </div>


            </div>
            <p style={{ fontSize: "1.3rem" }}>Note: International submissions are welcome. Authors based outside India may present accepted digests/papers in hybrid mode (online or onsite).</p>



            {/* ---------------- THEMES ONE BY ONE ---------------- */}
            <section className="section">
                <h2>Major Submission Themes</h2>

                {/* Energy */}
                <div className="theme-card">
                    <h3>Energy</h3>
                    <ul>
                        <li>Renewable Energy Technologies</li>
                        <li>Energy-efficient Building Design</li>
                        <li>Self-Reliant Eco Systems</li>
                        <li>AI/ML for Energy Optimisation</li>
                        <li>Traditional Use of Renewable Energy</li>
                        <li>Recycle Engineering (Energy Recovery & Resource Efficiency)</li>
                    </ul>
                </div>

                {/* Water */}
                <div className="theme-card">
                    <h3>Water</h3>
                    <ul>
                        <li>Water Resource Development & Conservation</li>
                        <li>Integrated Water Management through Innovative Technologies</li>
                        <li>Climate-Resilient Water Systems for Rural Livelihoods</li>
                        <li>Water Conservation and Wastewater Management</li>
                        <li>Ancient water harvesting and Irrigation systems</li>
                        <li>Water Education, Awareness, and Community Empowerment</li>
                    </ul>
                </div>

                {/* Ancient Knowledge Systems */}
                <div className="theme-card">
                    <h3>Ancient Knowledge Systems</h3>
                    <ul>
                        <li>Sustainability from an Indian Knowledge Systems Perspective</li>
                        <li>Sustainable Cultural Practices and Traditions</li>
                        <li>Women’s Role in Traditional Sustainable Societies</li>
                        <li>Science of Ancient Languages</li>
                        <li>AI/ML Applications for Sustainability (broader context)</li>
                        <li>Other Emerging Topics Related to Sustainability</li>
                    </ul>
                </div>
            </section>

            <section className="section">
                <h2>Guidelines for Paper Submission</h2>

                {/* Full guideline content with bullet points */}
                <div className="guidelines-box">
                    <ul>
                        <li>
                            The digest (short paper) must be written in the specified format:
                            <ul className="sublist">
                                <li>Font: Times New Roman</li>
                                <li>Font Size: 12-point</li>
                                <li>Single-line spacing</li>
                            </ul>
                        </li>

                        <li>
                            The digest must strictly follow the format:
                            <ul className="sublist">
                                <li>Abstract – 250 words</li>
                                <li>Methodology – max 500 words</li>
                                <li>Results & Discussion – max 500 words</li>
                                <li>Conclusion – 100 words</li>
                                <li>References</li>
                            </ul>
                        </li>

                        <li>It must be submitted in PDF format.</li>

                        <li>
                            The abstract should provide an impersonal, noncritical, and informative account.
                        </li>

                        <li>
                            The abstract should be grammatically accurate, clear, and fair in its treatment of the subject.
                        </li>

                        <li>
                            It must include a clear rationale or justification for the study — briefly stating
                            the purpose, need, and significance of the investigation.
                        </li>

                        <li>
                            Results & conclusions/recommendations should be outlined with emphasis on the significance of the work.
                        </li>

                        <li>No commercial promotion of entities, products, or services is permitted.</li>

                        <li>
                            Based on review by the academic committee:
                            <ul className="sublist">
                                <li>Some digests will be selected for oral presentation / PPT</li>
                                <li>Others may be asked to prepare a poster presentation</li>
                            </ul>
                        </li>

                        <li>
                            Please ensure that all co-authors of the work are listed and have approved the
                            final version of the submitted abstract.
                        </li>
                    </ul>
                </div>
            </section>



            {/* ---------------- FOUR Cs ---------------- */}
            <section className="section">
                <h2>The Four Cs of Digest Writing</h2>

                <div className="fourcs-grid">

                    <div className="fourcs-card">
                        <h3>Completeness</h3>
                        <p>
                            The digest covers all the major aspects of your research—objectives,
                            methods, findings, and conclusion.
                        </p>
                    </div>

                    <div className="fourcs-card">
                        <h3>Conciseness</h3>
                        <p>
                            The digest uses only essential and meaningful words, avoiding
                            unnecessary explanation.
                        </p>
                    </div>

                    <div className="fourcs-card">
                        <h3>Clarity</h3>
                        <p>
                            The digest is easy to read, well-structured, and grammatically
                            correct with a smooth flow.
                        </p>
                    </div>

                    <div className="fourcs-card">
                        <h3>Cohesiveness</h3>
                        <p>
                            All sections of the digest are logically linked, maintaining a
                            consistent message and flow.
                        </p>
                    </div>

                </div>
            </section>

            {/* Important Dates */}
            <section className="section">
                <h2>Important Dates</h2>

                <table className="dates-table">
                    <thead>
                        <tr>
                            <th>S. No</th>
                            <th>Details</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Last Date of Digest Submission</td>
                            <td>30 November 2025</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Acceptance Notification</td>
                            <td>05 December 2025</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Submission of Full-Length Papers (4-6 pages)</td>
                            <td>09 December 2025</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Last Date of Registration</td>
                            <td>09 December 2025</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>
    );
}


